var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.0387344C6.17879 0.0387344 2.71351 2.12936 0.15649 5.52508C-0.0521632 5.80328 -0.0521632 6.19195 0.15649 6.47016C2.71351 9.86997 6.17879 11.9606 10 11.9606C13.8212 11.9606 17.2865 9.86997 19.8435 6.47425C20.0522 6.19604 20.0522 5.80738 19.8435 5.52917C17.2865 2.12936 13.8212 0.0387344 10 0.0387344ZM10.2741 10.1973C7.73755 10.3568 5.64284 8.26621 5.80239 5.72555C5.93331 3.63084 7.63118 1.93298 9.72589 1.80206C12.2625 1.6425 14.3572 3.73312 14.1976 6.27378C14.0626 8.3644 12.3647 10.0623 10.2741 10.1973ZM10.1473 8.25803C8.78081 8.34394 7.65163 7.21885 7.74164 5.85238C7.81119 4.7232 8.72763 3.81085 9.85681 3.73721C11.2233 3.65129 12.3525 4.77638 12.2625 6.14286C12.1888 7.27613 11.2724 8.18847 10.1473 8.25803Z",
    fill: "#9197A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.46b529034b7eb713f59d3c6b717408da.svg";
export { ForwardRef as ReactComponent };